export const ORGANIZATION_INBOX_DIALOG_QUERY_PARAM = 'orgInboxDialog';
